import { isEditStoreLocationModal } from '../components/utils';
import { ROUTE_LOCATIONS } from '../constants';
import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID } from './pulseViewIds';

const isLocationsPagePath = (pathname?: string): boolean => {
  const path = (pathname ?? '').replace(/\/+$/, '');
  return path === ROUTE_LOCATIONS || path.startsWith(`${ROUTE_LOCATIONS}/`);
};

const resolveSearchLocationViewId = (pathname?: string): string => {
  if (isEditStoreLocationModal()) {
    return PULSE_VIEW_ID.EDIT_STORE_LOCATION_MODAL;
  }

  if (isLocationsPagePath(pathname)) {
    return PULSE_VIEW_ID.LOCATIONS;
  }

  return PULSE_VIEW_ID.LOCATION_SELECTOR_MODAL;
};

const resolveSearchLocationCategory = (): string => PULSE_CLICK_CATEGORY.ORDER_TYPE;

/** Location search input tap — fires when the user clicks/focuses the search field. */
export const trackSearchLocationInputClick = ({
  page_path,
  view_id,
  category,
}: {
  page_path?: string;
  view_id?: string;
  category?: string;
} = {}): void => {
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  const resolvedCategory = category ?? resolveSearchLocationCategory();

  trackPulseClick({
    category: resolvedCategory,
    action: PULSE_CLICK_ACTION.TAP_SEARCH_LOCATION,
    label: null,
    view_id: view_id ?? resolveSearchLocationViewId(path),
    page_id: resolvedCategory,
    page_path: path,
  });
};
